import React from "react";

const features = [
  "Finance",
  "Logistics",
  "Real Estate",
  "E-Commerce",
  "Health Care",
  "Taxi",
  "On-Demand",
  "Hospitality"
];

const BuilderSection = () => {
  return (
    <section className="py-20 px-4 bg-white max-w-6xl mx-auto">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div className="pe-8">
          {/* Badge */}
          <span className="text-[11px] bg-[#E6F5E8] text-[#137547] font-semibold px-4 py-1 rounded-full inline-block mb-4 tracking-wide uppercase">
            Industries we serve
          </span>

          {/* Heading */}
          <h2 className="text-3xl md:text-3xl font-extrabold text-[#0A033C] mb-4 leading-snug">
At Minterminds, we help businesses in all domains          </h2>

          {/* Subheading */}
          <p className="text-[#7C8BA1] mb-6 text-base leading-relaxed">
We aim to assist businesses across all sectors by crafting websites and applications that not only boast impressive designs but also deliver tangible outcomes. Our commitment lies in equipping your business with innovative web solutions at the forefront of technology.

          </p>

          {/* Divider */}
          <div className="border-b border-gray-200 mb-6"></div>

          {/* Feature Grid */}
          <div className="grid grid-cols-2 gap-y-4 gap-x-6">
            {features.map((item, index) => (
              <div key={index} className="flex items-start gap-2">
                <img src="/checkicon.png" alt="check" className="w-7 h-7" />
                <span className="text-[#0A033C] text-md font-semibold">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Right Image */}
        <div className="flex justify-center">
          <img
            src="/builder.png"
            alt="Builder UI"
            className="max-w-full"
          />
        </div>
      </div>
    </section>
  );
};

export default BuilderSection;
